export default __webpack_public_path__ + "static/media/lanternLeft.min.41b1a65f.png";